import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import swal from "sweetalert";
import ReactTooltip from "react-tooltip";
import { isMobile } from "react-device-detect";
import Style from "../../../assets/jsStyles";
import { productsList } from "../../../config/products";
import { CiRedo } from "react-icons/ci";
import { MapContext } from '../../../context/MapContext'
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const formData = new FormData();
const config = require("../../../config");

const MED9Form = (props) => {
  var dWidth = "130%";
  if (isMobile) {
    dWidth = "90%";
  }

  const [KFZW, setKFZW] = useState("");
  const [KFZW2, setKFZW2] = useState("");
  const [LAMFA, setLAMFA] = useState("");
  const [KRKATE, setKRKATE] = useState("");
  const [KFLDRL, setKFLDRL] = useState("");
  const [med9Type, setMed9Type] = useState("med9");
  const [password, setPassword] = useState("");
  const [type, setType] = useState("0");
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [KFZWColor, setKFZWColor] = useState("black");
  const [KFZW2Color, setKFZW2Color] = useState("black");
  const [LAMFAColor, setLAMFAColor] = useState("black");
  const [KRKATEColor, setKRKATEColor] = useState("black");
  const [KFLDRLColor, setKFLDRLColor] = useState("black");
  const [emailColor, setEmailColor] = useState("black");
  // const [userSubmittedCaptcha, setUserSubmittedCaptcha] = useState("");
  // const [captchaCode, setCaptchaCode] = useState("");
  const [otp, setOtp] = useState("")
  const [emailError, setEmailError] = useState(false);
  const [emailErrorText, setEmailErrorText] = useState("")
  const [loading, setLoading] = useState(false);


  // const generateCaptchaCode = () => {
  //   const characters =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   let captchaCode = "";
  //   for (let i = 0; i < 4; i++) {
  //     const randomIndex = Math.floor(Math.random() * characters.length);
  //     captchaCode += characters[randomIndex];
  //   }
  //   return captchaCode;
  // };

  // const generateNewCaptcha = () => {
  //   const newCaptchaCode = generateCaptchaCode();
  //   setCaptchaCode(newCaptchaCode);
  //   setUserSubmittedCaptcha("");
  // };

  // useEffect(() => {
  //   generateNewCaptcha();
  // }, []);

  const sendOtp = async () => {
    setLoading(true); // Set loading to true before sending OTP
    const requestData = {
      email: email
    }
    try {
      const response = await fetch(`${config.HOST}/otp/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      console.log("this is the response for the handleEmailVerify response", data)
      if (data.code === 0) {
        setEmailError(data.message)
      }
      else if (data.code === 1) {
        console.log("successful")
        setEmailSent(true)
      }
    }
    catch (error) {
      console.log("this is the error in the verify email", error)
    }
    finally {
      setLoading(false); // Set loading back to false after sending OTP
    }
  }


  const hexInputsMemoized = useMemo(
    () => [
      {
        input: KFZW,
        name: "KFZW",
        action: setKFZWColor,
      },
      {
        input: KFZW2,
        name: "KFZW2",
        action: setKFZW2Color,
      },
      {
        input: LAMFA,
        name: "LAMFA",
        action: setLAMFAColor,
      },
      {
        input: KRKATE,
        name: "KRKATE",
        action: setKRKATEColor,
      },
      {
        input: KFLDRL,
        name: "KFLDRL",
        action: setKFLDRLColor,
      },
    ],
    [KFZW, KFZW2, LAMFA, KRKATE, KFLDRL]
  );

  const hexCheckRegex = useMemo(() => new RegExp(/^[0-9A-Z]{6}$/), []);
  const emailRegex = useMemo(() => /\S+@\S+\.\S+/, []);

  useEffect(() => {
    for (let i in hexInputsMemoized) {
      if (hexCheckRegex.test(hexInputsMemoized[i]["input"])) {
        hexInputsMemoized[i]["action"]("green");
      }
    }
    if (emailRegex.test(email)) {
      setEmailColor("green");
    }
  }, [hexInputsMemoized, email, hexCheckRegex, emailRegex]);

  const mainFormOnSubmit = (evt) => {
    evt.preventDefault();
    formData.delete("KFZW");
    formData.delete("KFZW2");
    formData.delete("LAMFA");
    formData.delete("KRKATE");
    formData.delete("KFLDRL");
    formData.delete("type");
    formData.delete("email");
    formData.delete("password");
    formData.delete("otp")

    formData.append("KFZW", KFZW);
    formData.append("KFZW2", KFZW2);
    formData.append("LAMFA", LAMFA);
    formData.append("KRKATE", KRKATE);
    formData.append("KFLDRL", KFLDRL);
    formData.append("type", type);
    formData.append("email", email);
    formData.append("password", password);
    formData.append('otp', otp)
    let error = "";

    for (let i in hexInputsMemoized) {
      if (hexCheckRegex.test(hexInputsMemoized[i]["input"])) {
        hexInputsMemoized[i]["action"]("green");
      } else {
        error = error + `Invalid ${hexInputsMemoized[i]["name"]} value\n`;
        hexInputsMemoized[i]["action"]("red");
      }
    }

    if (!emailRegex.test(email)) {
      error = error + "Invalid email address\n";
    } else {
      setEmailColor("green");
    }

    // let captchaTest = captchaCode === userSubmittedCaptcha ? true : false;

    // if (!captchaTest) {
    //   error = error + "Invalid captcha";
    // }

    if (error) {
      swal({
        title: "Invalid Inputs",
        text: error,
        icon: "error",
      });
    } else {
      props.setLoader(true);
      axios
        .post(`${config.HOST}/file/med9converter`, formData)
        .then((res) => {
          props.setLoader(false);
          swal({
            title: "File Converted Successfully!",
            text: "Pay and download your file instantly.",
            icon: "success",
            button: "Pay Now",
          }).then((flag) => {
            if (flag) {
              window.location = res.data.data;
              //props.setProduct(res.data.data, parseInt(type));
            }
          });
        })
        .catch((e) => {
          props.setLoader(false);
          console.log(e.response.data);
          swal({
            title: "Something went wrong.",
            text: e.response.data.message,
            icon: "error",
          });
        });
    }
    // generateNewCaptcha();
  };

  const uploadFile = (evt) => {
    evt.preventDefault();
    let file = evt.target.files[0];
    if (file.size > 2197152) {
      setMed9Type("med9.1.5");
    } else {
      setMed9Type("med9");
    }
    formData.delete("binFile");
    if (file) {
      formData.append("binFile", file);
    }
  };

  return (
    <>
      <form onSubmit={mainFormOnSubmit} style={Style.form}>
        <input
          type="file"
          onChange={uploadFile}
          name="binFile"
          accept=".bin, .Bin, .BIN"
          placeholder="Put your bin file here"
          style={Style.uploadButton(dWidth)}
        ></input>
        {process.env.REACT_APP_ENV !== "PROD" ? (
          <input
            type="password"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            name="password"
            placeholder="Enter Password"
            style={Style.formInput(dWidth, "black")}
            value={password}
          ></input>
        ) : null}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "10% 90%",
            fontSize: "2em",
            alignItems: "center",
            marginLeft: "5%",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: "0.8em",
              marginRight: "2px",
            }}
          >
            0x
          </div>
          <input
            type="text"
            onChange={(e) => {
              setKFZW(e.target.value);
            }}
            data-tip="Enter Address in hex to patch or 0 to skip this map"
            data-type="info"
            name="KFZW"
            className="med9InputHex"
            placeholder="KFZW Hexadecimal Input"
            style={Style.formInput(dWidth, KFZWColor)}
            value={KFZW}
          ></input>

        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "10% 90%",
            fontSize: "2em",
            alignItems: "center",
            marginLeft: "5%",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: "0.8em",
              marginRight: "2px",
            }}
          >
            0x
          </div>
          <input
            type="text"
            onChange={(e) => {
              setKFZW2(e.target.value);
            }}
            name="KFZW2"
            data-tip="Enter Address in hex to patch or 0 to skip this map"
            data-type="info"
            className="med9InputHex"
            placeholder="KFZW2 Hexadecimal Input"
            style={Style.formInput(dWidth, KFZW2Color)}
            value={KFZW2}
          ></input>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "10% 90%",
            fontSize: "2em",
            alignItems: "center",
            marginLeft: "5%",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: "0.8em",
              marginRight: "2px",
            }}
          >
            0x
          </div>
          <input
            data-tip="For this map, enter the address of 1st byte of the actual map, NOT the 1st byte of axis"
            data-type="info"
            type="text"
            onChange={(e) => {
              setLAMFA(e.target.value);
            }}
            name="LAMFA"
            className="med9InputHex"
            placeholder="LAMFA Hexadecimal Input"
            style={Style.formInput(dWidth, LAMFAColor)}
            value={LAMFA}
          // data-event="focus"
          // data-scroll-hide="false"
          // data-event-off="blur"
          ></input>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "10% 90%",
            fontSize: "2em",
            alignItems: "center",
            marginLeft: "5%",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: "0.8em",
              marginRight: "2px",
            }}
          >
            0x
          </div>
          <input
            type="text"
            onChange={(e) => {
              setKRKATE(e.target.value);
            }}
            data-tip="Enter Address in hex to patch or 0 to skip this map"
            data-type="info"
            name="KRKATE"
            className="med9InputHex"
            placeholder="KRKATE Hexadecimal Input"
            style={Style.formInput(dWidth, KRKATEColor)}
            value={KRKATE}
          ></input>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "10% 90%",
            fontSize: "2em",
            alignItems: "center",
            marginLeft: "5%",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: "0.8em",
              marginRight: "2px",
            }}
          >
            0x
          </div>
          <div>
            <input
              type="text"
              onChange={(e) => {
                setKFLDRL(e.target.value);
              }}
              data-tip="Enter Address in hex to patch or 0 to skip this map"
              data-type="info"
              name="KFLDRL"
              className="med9InputHex"
              placeholder="KFLDRL Hexadecimal Input"
              style={Style.formInput(dWidth, KFLDRLColor)}
              value={KFLDRL}
            ></input>
            <ReactTooltip effect='solid' />
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            width: dWidth
          }}>
          <input
            type="text"
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailSent(false)
            }}
            name="email"
            placeholder="Enter your email"
            style={Style.formInput(dWidth,emailColor)}
            value={email}
          ></input>

          {(!emailSent && !loading) && <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: '8px',
              padding: '0px 15px',
              color: 'white',
              background: 'blue',
              borderRadius: '10px'
            }}
            className="text-xs"
            onClick={sendOtp}
          >Send <span className="ml-1">OTP</span></div>
          }
          {
            (!emailSent && loading)&& <div className="loader text-sm"   
               style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: '8px',
              padding: '0px 15px',
              color: 'white',
              background: 'blue',
              borderRadius: '10px'
            }} > <FontAwesomeIcon icon={faSpinner} spin /></div>
          }
          {emailSent&&<div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: '8px',
              padding: '0px 20px',
              color: 'white',
              background: 'rgb(106,181,39)',
              borderRadius: '10px',
              fontSize: '12px'
            }}
          >Sent <span>✓</span></div>
          }
        </div>
        {emailError && <div style={{
          paddingLeft: "32px",
          color: "red"
        }}>
          {emailErrorText}</div>}

        <div>
          <input
            type="text"
            onChange={(e) => {
              if (e.target.value.length <= 6) {
                setOtp(e.target.value);
              }
            }}
            name="OTP"
            placeholder="OTP"
            style={Style.formInput(dWidth)}
            value={otp}
          ></input>
        </div>

        <select
          onChange={(e) => {
            setType(e.target.value);
          }}
          style={Style.formInput(dWidth, "black")}
          name="type"
          value={type}
        >
          {med9Type &&
            productsList.med9.map((data, i) => {
              if (med9Type && med9Type === "med9" && i <= 1) {
                return (
                  <option value={`${i}`} key={i}>
                    {data.description} &euro; {data.price}
                  </option>
                );
              } else if (med9Type && med9Type === "med9.1.5" && i > 1) {
                return (
                  <option value={`${i - 2}`} key={i}>
                    {data.description} &euro; {data.price}
                  </option>
                );
              } else {
                return null;
              }
            })}
          {!med9Type && <option key={8}></option>}
        </select>
        {/* <div style={Style.recaptchaOuter(dWidth)}>
          <div style={Style.captchaBox()}>
            {" "}
            <span>{captchaCode}</span>{" "}

            <CiRedo id="retryButton" onClick={generateNewCaptcha} />
          </div>

          <input
            type="text"
            name="clientCode"
            style={Style.formInput("90%", "black")}
            onChange={(e) => {
              setUserSubmittedCaptcha(e.target.value);
            }}
            value={userSubmittedCaptcha}
          />
        </div> */}
        <input
          type="submit"
          style={Style.formInput(dWidth, "black", "60px", "18px")}
          value="Pay & Download"
        ></input>
      </form>
      <p style={Style.disclaimer}>
        *All data must be from engine ECU.<br></br>
        *No refunds, make sure all data is correct.
      </p>
    </>
  );
};

export default MED9Form;
